import addSeedPopup from './addSeedPopup.html';

angular
  .module('cfn')
  .controller('seedPlanningController', [
    '$scope',
    '$log',
    '$q',
    'storage',
    'seedPlanningModel',
    'seedPlanningSummaryModel',
    'CfnDialogService',
    'i18nFilter',
    'EVENT_CHART_RESIZE',
    seedPlanningController
  ]);

function seedPlanningController(
  $scope,
  $log,
  $q,
  storage,
  seedPlanningModel,
  seedPlanningSummaryModel,
  CfnDialogService,
  i18nFilter,
  EVENT_CHART_RESIZE
) {
  'use strict';

  // Column indices [from, to] of non-fixed columns for planned seeds
  let dynamicSeedColumnRange = [7, 31];

  // Scope of grid to access it directly
  let gridScope;

  // Promise that is resolves as soon as the grid is ready
  let gridReady = $q.defer();

  /**
   * Initialization stuff
   */
  var init = function() {
    autoCurrentUiStep(null);

    $scope.resultModel = [];

    let allowedYears = app.farmnetControllers.data.allowedYears;
    $scope.allowedYears = _.sortBy(allowedYears, (val) => { return val; } ).reverse();

    $scope.fnMessage = {
      show: false,
      type: 'info',
      message: ''
    };

    $scope.addSeedPopup = addSeedPopup;

    // Remember the planning that has been edited the last time
    storage.bind($scope, 'selectedYear', {
      defaultValue: null,
      storeName: 'seedPlanningYear'
    });
    storage.bind($scope, 'selectedCulture', {
      defaultValue: null,
      storeName: 'seedPlanningCulture'
    });
  };

  $scope.$watch('model', function() {
    updateListView();
  });

  init();

  function updateListView() {
    if ($scope.model) {
      $scope.byFarmCropField = seedPlanningSummaryModel.getByFarmByCropByFields(
        $scope.model.farms,
        $scope.model.seedColumns,
        $scope.model.rows
      );
      $scope.hasData = Object.keys($scope.byFarmCropField).length > 0;
    } else {
      $scope.byFarmCropField = {};
      $scope.hasData = false;
    }
  }

  /**
   * Grid is ready
   */
  $scope.onGridInited = function(grid, scope) {
    $scope.gridScope = gridScope = scope;
    gridReady.resolve();
    $scope.isGridInitialized = true;
  };

  /**
   * Quick fill with remaining area on click
   */
  $scope.onFocusArea = function(item, seedNr) {
    if (!item.seeds[seedNr].plannedArea) {
      var remainingArea = item.plannedArea;
      item.seeds.forEach(function(seed) {
        if (seed.plannedArea) {
          remainingArea -= seed.plannedArea;
        }
      });
      if (remainingArea > 0) {
        item.seeds[seedNr].plannedArea = remainingArea;
      }
    }
  };

  /**
   * Popup to add seed closed
   */
  $scope.onAddSeedResult = function(items) {
    items.forEach(function(ob) {
      var newSeed = ob.data;
      var maxNumberColumns =
        dynamicSeedColumnRange[1] - dynamicSeedColumnRange[0] + 1;
      var alreadyExists;

      $log.debug('Seleted seed ' + newSeed.name + '/' + newSeed.id);

      if ($scope.model.seedColumns.length >= maxNumberColumns) {
        return;
      }

      alreadyExists = $scope.model.seedColumns.some(function(el) {
        return el.id === newSeed.id;
      });

      if (alreadyExists) {
        return;
      }

      // Load full DTO
      seedPlanningModel.loadSeed(newSeed.id).then(function(newSeed) {
        if ($scope.model.seedColumns.length >= maxNumberColumns) {
          return;
        }

        $scope.model.seedColumns.push(newSeed);

        buildModel();
      });
    });
  };

  function buildModel() {
    $scope.model.rows.forEach(function(row) {
      var seedRow = {
        seedStrength: null,
        plannedArea: null
      };

      row.seeds.push(seedRow);
    });

    // Build columns that match to the currently planned seeds
    // Actually this would only have to be called once after all have been added
    buildColumns();
  }

  $scope.getCurrentAddBtnPosition = function() {
    var topPos = $scope.gridScope
      ? Math.max(0, $scope.gridScope.viewData.length * 26 / 2 - 13) + 'px'
      : '0px';
    // position button at a position in the middle of the column. if there are less lineitems the position will be higher
    return { top: topPos };
  };

  $scope.removeSeedFromPlan = function(col) {
    if (!col.item) {
      return;
    } // check if wrong column

    // remove column
    if (!col.item.canNotBeRemoved) {
      CfnDialogService.showYesNoDialog(
        i18nFilter('fe.common.delete', 'Löschen'),
        i18nFilter('fe.common.areYouSure', 'Sind Sie sicher?'),
        function() {
          doRemoveSeedFromPlan(col.item.id);
        }
      );
    } else {
      CfnDialogService.showMessage(
        i18nFilter(
          'fe.common.msgCouldNotDelete.title',
          'Kann nicht entfernt werden.'
        ),
        i18nFilter(
          'fe.planning.seedPlanning.msgCouldNotDelete',
          'Diese Sorte kann nicht entfernt werden, da sie bereits in Buchungen verwendet wird.'
        )
      );
    }
  };

  function doRemoveSeedFromPlan(id) {
    var seedOrderNr;

    for (seedOrderNr in $scope.model.seedColumns) {
      if ($scope.model.seedColumns[seedOrderNr].id === id) {
        break;
      }
    }

    _.each($scope.model.rows, function(row) {
      row.seeds.splice(seedOrderNr, 1);
    });

    $scope.model.seedColumns.splice(seedOrderNr, 1);
    // Refresh grid
    buildColumns();
  }

  /**
   * Called when harvest year has been changed
   */
  $scope.$watch('selectedYear', function(newValue, oldValue) {
    autoCurrentUiStep(null);
    if (newValue) {
      app.showLoader();
      seedPlanningModel
        .loadPlannedCultures($scope.selectedYear)
        .then(function(result) {
          app.hideLoader();
          $scope.plannedCultures = result;
          $scope.hasNoCropplanning =
            $scope.plannedCultures &&
            Object.getOwnPropertyNames($scope.plannedCultures).length === 0;
          autoCurrentUiStep();
        });
      angular.element(document.querySelector('th.col2 > div > span.second-title')).text(newValue - 3);
      angular.element(document.querySelector('th.col3 > div > span.second-title')).text(newValue - 2);
      angular.element(document.querySelector('th.col4 > div > span.second-title')).text(newValue - 1);
    } else {
      $scope.currentUiStep = 1;
      $scope.plannedCultures = null;
      $scope.hasNoCropplanning = false;
      autoCurrentUiStep();
    }

    // Don't reset the culture on initialization
    if (newValue !== oldValue) {
      $scope.selectedCulture = null;
    }
  });

  /**
   * Called when selected culture has been changed
   */
  $scope.$watch('selectedCulture', function(newValue, oldValue) {
    if (newValue) {
      app.showLoader();
      seedPlanningModel
        .loadPlanning($scope.selectedYear, $scope.selectedCulture)
        .then(function(result) {
          var rowCount = result.rows.length;
          result.rows = result.rows.filter(function(row) {
            return row.field.isActive;
          });

          if (rowCount !== result.rows.length) {
            $scope.fnMessage.show = true;
            $scope.fnMessage.type = 'info';
            $scope.fnMessage.message = i18nFilter(
              'fe.planning.seedPlanning.invalidField.message',
              'Achtung! Die aktuelle Planung enthält inaktive Schläge und/oder inaktive Teilbetriebe die nicht dargestellt werden. Wenn Sie mit den Daten planen wollen, dann aktivieren Sie diese im Bereich ‚Verwalten‘.'
            );
          } else {
            $scope.fnMessage.show = false;
          }

          $scope.model = result;
          var colNumber = 0;
          _.each(result.seedColumns, function(col) {
            col.canNotBeRemoved = _.any(result.rows, function(row) {
              return row.seedsReadOnly;
            });
            colNumber++;
          });
          buildColumns();
          app.hideLoader();
          autoCurrentUiStep();
        });
    } else {
      $scope.model = undefined;
      autoCurrentUiStep();
    }
  });

  /**
   * Called when view model has been changed which could make a save necessary
   */
  $scope.$watch(
    'model',
    function(newValue, oldValue) {
      if (!newValue) {
        return;
      }

      // Update calculated values
      $scope.model.rows.forEach(function(row) {
        var totalPlannedArea = 0;
        row.seeds.forEach(function(seed) {
          if (seed && seed.plannedArea) {
            // Workaround: parseFloat because cfnInput returns strings for edited fields
            totalPlannedArea += parseFloat(seed.plannedArea);
          }
        });
        row.view = row.view || {};
        row.view.sumPlannedSeeds = totalPlannedArea;
      });

      $scope.summaryModel = seedPlanningSummaryModel.getSummary(
        $scope.model.seedColumns,
        $scope.model.rows
      );

      // Notify service that something could have changed
      seedPlanningModel.onChangedViewModel($scope.model);
    },
    true
  );

  function autoCurrentUiStep(override) {
    var isStep1 = true,
      isStep2 = !!$scope.selectedYear && !$scope.hasNoCropplanning,
      isStep3 = !!$scope.selectedYear && !!$scope.selectedCulture,
      currentUiStep = null;

    if (override) {
      currentUiStep = override;
    } else {
      switch (true) {
        case isStep3:
          currentUiStep = 3;
          break;

        case isStep2:
          currentUiStep = 2;
          break;

        case isStep1:
          currentUiStep = 1;
          break;

        default:
          currentUiStep = null;
          break;
      }
    }

    $scope.currentUiStep = currentUiStep;
  }

  /**
   * "Creates" dynamic columns based on selected seeds
   */
  function buildColumns() {
    // Make sure our grid is ready to be modified
    gridReady.promise.then(function() {
      var firstColumn = dynamicSeedColumnRange[0];
      var lastColumn = dynamicSeedColumnRange[1];
      for (var colIndx = firstColumn; colIndx <= lastColumn; colIndx++) {
        var seeds = $scope.model.seedColumns;
        var seedIndex = colIndx - firstColumn;

        if (seeds.length > seedIndex) {
          gridScope.columns[colIndx].hidden = 'false';
          gridScope.columns[colIndx].title = seeds[seedIndex].name;
          gridScope.columns[colIndx].item = seeds[seedIndex];
        } else {
          gridScope.columns[colIndx].hidden = 'true';
        }
      }

      // Apply new visibility state
      gridScope.calculateWidths();
    });
  }

  $scope.printThis = function() {
    window.print();
  };

  // Filter for innerHTML grid columns of previous crops
  $scope.abbrFruitFilter = function(filterText, modelRow, columnName) {
    var abbrFruit = '', culture;
    // Fetch abbreviation of culture to filter it
     if (culture = modelRow[columnName]) {
       abbrFruit = culture.abbrFruit; 
       return abbrFruit.toLowerCase().indexOf(filterText.toLowerCase()) > -1;
      } else {
        return false;
     }
  };

  /**
   * Segment control vars.
   */
  _.extend($scope, {
    viewmode: null, // no view mode set until active tab view is resolved
    seedPlanningSegments: [
      // label data for segment control
      {
        label: 'fe.planning.breadcrumb',
        icon: 'dots',
        onSelect: function() {
          $scope.gridScope.gridController.refresh();
          $scope.viewmode = 'PLANNINGVIEW';
        },
        selected: true
      },
      {
        label: 'fe.common.overview',
        icon: 'bars',
        onSelect: function() {
          updateListView();
          $scope.viewmode = 'LISTVIEW';
        }
      }
    ],
    // Flag for grid initialization.
    // This flag is needed because tab switch relies on initialized grid data.
    // We can only display the segment control after the grid has been initialized, otherwise we run into NPE.
    isGridInitialized: false
  });
}
